// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorCustomers = (client) => ({
    /**
     * `POST /vendor/customers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateSellerCustomer
     * @source packages/modules/b2c-core/src/api/vendor/customers/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/customers", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/customers/:id/customer-groups`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorLinkCustomerToCustomerGroups
     * @source packages/modules/b2c-core/src/api/vendor/customers/[id]/customer-groups/route.ts
     */
    createCustomerGroup: (id, body, query, headers) => client.fetch(buildPath("/vendor/customers/:id/customer-groups", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/customers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListSellerCustomers
     * @source packages/modules/b2c-core/src/api/vendor/customers/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/customers", { method: "GET", query, headers }),
    /**
     * `GET /vendor/customers/:id/orders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListOrdersByCustomerId
     * @source packages/modules/b2c-core/src/api/vendor/customers/[id]/orders/route.ts
     */
    listOrders: (id, query, headers) => client.fetch(buildPath("/vendor/customers/:id/orders", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/customers/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetCustomer
     * @source packages/modules/b2c-core/src/api/vendor/customers/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/customers/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/customers/:id/sales-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetCustomerSalesManager
     * @source packages/modules/b2c-core/src/api/vendor/customers/[id]/sales-manager/route.ts
     */
    retrieveSalesManager: (id, query, headers) => client.fetch(buildPath("/vendor/customers/:id/sales-manager", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/customers/:id/sales-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAssignCustomerSalesManager
     * @source packages/modules/b2c-core/src/api/vendor/customers/[id]/sales-manager/route.ts
     */
    updateSalesManager: (id, body, query, headers) => client.fetch(buildPath("/vendor/customers/:id/sales-manager", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/customers/sales-manager/bulk`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCustomersSalesManagerBulkTransferCreate
     * @source packages/modules/b2c-core/src/api/vendor/customers/sales-manager/bulk/route.ts
     */
    updateSalesManagerBulk: (body, query, headers) => client.fetch("/vendor/customers/sales-manager/bulk", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=customers.js.map